import BaseHlsJsInteraction from './BaseHlsJsInteraction';
import {
  HLSjsInteractionOptions,
  XhrLoaderGenerator
} from '../webrtc/bindHLSjsToWebRTC';
import logger from '../log';
import { Flowplayer, HLSjsConfig } from '@kollective-frontend/ksdk-api';

const log = logger.getLogger(__filename);

export default class FlowplayerHLSjsInteraction extends BaseHlsJsInteraction<Flowplayer> {
  setSrc?: (url: string) => void;
  loaderGenerator?: XhrLoaderGenerator;
  constructor(player: Flowplayer, option?: HLSjsInteractionOptions) {
    super(player, player.hls, option);
    player.addEventListener('src', () => this.handleFlowplayerEvent());
  }

  initialize(): void {
    super.initialize();
    setInterval(() => {
      const conf = this.player?.hls?.config as HLSjsConfig;
      if (this.checkLoaderMatch(this.loaderGenerator, conf)) {
        conf.loader = this.loaderGenerator;
        conf.fLoader = this.loaderGenerator;
        conf.pLoader = this.loaderGenerator;
        this.hls = this.player.hls;
      }
    }, 200);
  }

  protected bindHls(): void {
    super.bindHls();
    this.loaderGenerator = this.hls?.config?.loader as XhrLoaderGenerator;
  }

  // VisibleForTesting
  checkLoaderMatch(loader: unknown, config?: HLSjsConfig): boolean {
    if (!loader || !config) {
      return false;
    }
    return (
      loader !== config.fLoader ||
      loader !== config.loader ||
      loader !== config.pLoader
    );
  }

  handleFlowplayerEvent() {
    // Flowplayer3 re-creates the hls object when setSrc is called, the
    // 'src' event is triggered when setSrc is called. We use the 'src'
    // event to update our hls bindings.
    const isEqual = this.hls === this.player.hls;
    if (!isEqual && this.player.hls) {
      log.info('Updating hlsBindings');
      this.resetHls(this.player.hls);
    } else {
      log.debug('flowplayer src event handled but unable to rebind, retrying');
      setTimeout(() => this.handleFlowplayerEvent(), 0);
    }
  }

  setSource(url: string): void {
    this.player.setSrc(url);
  }

  clearSource(): void {
    this.player.destroy();
  }
}
